/**
 * Resolves the identifier printed top-left on a tote label and embedded in its QR payload.
 *
 * Amended DSP orders carry poaChildOrderId — the MAIN order's child order id — and must
 * print that rather than their own childOrderId, so a backoffice label matches the one the
 * Picker app prints for the same tote (LIT-548). Ordinary DSP orders keep printing their
 * own child order id (LIT-493), and DBP orders fall back to the reference number.
 *
 * Uses `||` rather than `??` because the API returns '' for unset string fields, which
 * `??` would accept as a valid id and print a blank label.
 */
export const resolvePrintOrderId = ({
  poaChildOrderId,
  childOrderId,
  orderReferenceNumber,
} = {}) => poaChildOrderId || childOrderId || orderReferenceNumber

export default resolvePrintOrderId
